import { forgetStored } from '../lib/stored'

/** Where this browser keeps an account's impact sessions (ANN-36): one entry per account. */
export const KEPT_PREFIX = 'pedfx.impact.'

/** Only this account's sessions stay in this browser, as its named classes do (LBL-08). */
export const forgetImpactSessions = (keep: string) => forgetStored((key) => key.startsWith(KEPT_PREFIX) && key !== `${KEPT_PREFIX}${keep}`)
